import { PrintTemplate } from '../types';

class PrintService {
  async generatePDF(type: string, data: any): Promise<string> {
    // Simulation de génération PDF
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // En réalité, cela utiliserait une librairie comme jsPDF ou appellerait une API
    const mockPdfUrl = `data:application/pdf;base64,JVBERi0xLjQKJdPr6eEKMSAwIG9iago8PAovVGl0bGUgKCR7dHlwZX0pCi9Qcm9kdWNlciAoSEVSTUlORVRURSkKL0NyZWF0aW9uRGF0ZSAoRDoke25ldyBEYXRlKCkudG9JU09TdHJpbmcoKX0pCj4+CmVuZG9iagp4cmVmCjAgMQowMDAwMDAwMDAwIDY1NTM1IGYgCnRyYWlsZXIKPDwKL1NpemUgMQovUm9vdCAxIDAgUgo+PgpzdGFydHhyZWYKMTczCiUlRU9G`;
    
    return mockPdfUrl;
  }

  async generateQuotePDF(quoteId: string): Promise<string> {
    const data = {
      type: 'Devis',
      number: quoteId,
      date: new Date().toLocaleDateString('fr-FR'),
      company: 'HERMINETTE',
      logo: '/logo Herminette (baseline).png'
    };
    
    return this.generatePDF('quote', data);
  }

  async generateOrderPDF(orderId: string): Promise<string> {
    const data = {
      type: 'Bon de préparation',
      number: orderId,
      date: new Date().toLocaleDateString('fr-FR'),
      company: 'HERMINETTE'
    };
    
    return this.generatePDF('order', data);
  }

  async generateDeliveryPDF(orderId: string): Promise<string> {
    const data = {
      type: 'Bon de livraison',
      number: orderId,
      date: new Date().toLocaleDateString('fr-FR'),
      company: 'HERMINETTE'
    };
    
    return this.generatePDF('delivery', data);
  }

  async generateSupplierOrderPDF(orderId: string): Promise<string> {
    const data = {
      type: 'Commande fournisseur',
      number: orderId,
      date: new Date().toLocaleDateString('fr-FR'),
      company: 'HERMINETTE'
    };
    
    return this.generatePDF('supplier_order', data);
  }

  async generateInventoryPDF(sessionId: string): Promise<string> {
    const data = {
      type: 'PV d\'inventaire',
      number: sessionId,
      date: new Date().toLocaleDateString('fr-FR'),
      company: 'HERMINETTE'
    };
    
    return this.generatePDF('inventory', data);
  }

  async generateConsumptionReportPDF(chantierId: string, period: string): Promise<string> {
    const data = {
      type: 'Rapport de consommation',
      chantier: chantierId,
      period,
      date: new Date().toLocaleDateString('fr-FR'),
      company: 'HERMINETTE'
    };
    
    return this.generatePDF('consumption', data);
  }

  async exportCSV(data: any[], filename: string): Promise<void> {
    // Simulation d'export CSV
    await new Promise(resolve => setTimeout(resolve, 500));
    
    if (!data.length) return;
    
    const headers = Object.keys(data[0]);
    const csvContent = [
      headers.join(';'),
      ...data.map(row => headers.map(header => row[header] || '').join(';'))
    ].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `${filename}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  downloadPDF(pdfUrl: string, filename: string): void {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = `${filename}.pdf`;
    link.click();
  }
}

export const printService = new PrintService();